import { render, staticRenderFns } from "./open-update-sys.vue?vue&type=template&id=5c927a39&scoped=true&"
import script from "./open-update-sys.vue?vue&type=script&lang=js&"
export * from "./open-update-sys.vue?vue&type=script&lang=js&"
import style0 from "./open-update-sys.vue?vue&type=style&index=0&id=5c927a39&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c927a39",
  null
  
)

export default component.exports